var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('h4',{staticClass:"text-center align-middle"},[_vm._v("空空如也 "),_c('i',{staticClass:"far fa-flushed"})]),_c('br')])}]

export { render, staticRenderFns }